module.exports = __webpack_public_path__ + "img/background9.aa9caf68.png";